import {
  Component,
  Input,
  Output,
  OnDestroy,
  OnInit,
  EventEmitter,
} from "@angular/core";
import { NgStyle, NgClass, CommonModule } from "@angular/common";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { SectionDescriptionComponent } from "../section-description/section-description.component";

import { sortingSVG } from "src/constants/svg/sorting-svg";
import { filterSVG } from "src/constants/svg/filter-svg";
import { SearchSvgComponent } from "src/constants/svg/search-svg.component";
import { GetValueFromListPipe } from "src/pipes/get-value-from-list.pipe";
import { SafeHtmlPipee } from "src/pipes/safe-html1.pipe";
import { SafeHTMLPipe } from "src/pipes/safe-html.pipe";

@Component({
  selector: "app-header-filter",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgStyle,
    NgClass,
    SectionDescriptionComponent,
    SearchSvgComponent,
    GetValueFromListPipe,
    CommonModule,
    SafeHtmlPipee,
  ],
  templateUrl: "./header-filter.component.html",
  styleUrls: ["./header-filter.component.scss"],
})
export class HeaderFilterComponent implements OnInit, OnDestroy {
  readonly sortingSVG = sortingSVG;
  readonly filterSVG = filterSVG;
  readonly searchControl = new FormControl();
  readonly control = new FormControl(false);
  @Input() sortByOptions: {
    label: string;
    value: string;
  }[] = [
    {
      label: "Alphabetical (A-Z)",
      value: "name:ASC",
    },
    {
      label: "Alphabetical (Z-A)",
      value: "name:DESC",
    },
    {
      label: "Trending",
      value: "view:DESC",
    },
    {
      label: "New on AIKosh",
      value: "createdAt:DESC",
    },
  ];
  private searchKeywordSubs!: Subscription;
  private checkboxSubs!: Subscription;

  @Input() headerFilter!: any;
  @Input() showSort = true;
  @Input() sortBy!: string;
  @Input() isFilterApplied!: boolean;
  @Input() isShowFilter = true;
  @Input() isShowExportbtn!: boolean;
  @Input() isCheckboxVisible = false;
  @Output() onShowFilters = new EventEmitter<void>();
  @Output() onSortSelect = new EventEmitter<string>();
  @Output() onSearchByText = new EventEmitter<string>();
  @Output() exportExcel = new EventEmitter();
  @Output() onCheckboxChange = new EventEmitter<boolean>();
  @Input() showSearchOnly = false;

  ngOnInit() {
    this.searchKeywordSubs = this.searchControl.valueChanges
      .pipe(debounceTime(2000))
      .subscribe((value) => {
        this.onSearchByText.emit(value?.trim() || "");
      });

    this.checkboxSubs = this.control.valueChanges.subscribe((value) => {
      this.onCheckboxChange.emit(value || false);
    });
  }

  ngOnDestroy() {
    this.searchKeywordSubs.unsubscribe();
    if (this.checkboxSubs) {
      this.checkboxSubs.unsubscribe();
    }
  }
}
